import ky from "ky";

import { BASE_URL } from "./constants/index";
import { envelopeHook } from "./hooks/envelope";

// Minimal instance for feature flag requests — envelope unwrap only.
// No auth hooks, no error toasts, no loader, no token refresh.
// Auth is set per-request via an explicit Authorization header.
// This intentionally avoids hooks that import the redux store, keeping
// the featureFlag action/middleware modules free of store cycles.
//
// retry: 0 — see base.ts for rationale; same parity-with-axios reasoning applies.
export const httpFeatureFlag = ky.create({
  hooks: {
    afterResponse: [envelopeHook],
  },
  prefix: BASE_URL,
  retry: 0,
  throwHttpErrors: true,
});
